import React from 'react';
import { Grid, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttSelectMship } from '../../../sporttia/all';
import SalePointProducts from './SalePointProducts';
import SalePointCart from './SalePointCart';
import SalePointPayment from './SalePointPayment';
import type { SalePointState } from './useSalePoint';

type Props = {
    salePoint: SalePointState;
};

/**
 * Contenido del punto de venta: productos, comprador, carrito y cobro. Sólo
 * pinta; el estado y las llamadas viven en `useSalePoint`, así que sirve igual
 * dentro de la página y dentro del diálogo de un ticket.
 *
 * No limita el ancho: la página ya lo hace con el del contenido del gestor y el
 * diálogo lo centra con su propio `Container`.
 */
export default function SalePointBody({
    salePoint,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const {
        cart,
        mship,
        setMship,
        ticket,
        setTicket,
        allProducts,
        setAllProducts,
        readOnly,
        canManageProducts,
        totalNet,
        totalVat,
        total,
        onSelectProduct,
        saveMovementInCart,
        updateProduct,
        deleteProduct,
        reset,
    } = salePoint;

    return (
        <Box className="mt-6">
            <Grid container spacing={4} justifyContent="center">
                {!readOnly && (
                    <Grid size={{ md: 6, sm: 12, xs: 12 }}>
                        <SalePointProducts
                            selectProduct={onSelectProduct}
                            allProducts={allProducts ?? []}
                            setAllProducts={setAllProducts as any}
                            onUpdateProduct={updateProduct}
                            onDeleteProduct={deleteProduct}
                            canManageProducts={canManageProducts}
                        />
                    </Grid>
                )}

                <Grid size={{ md: 6, sm: 12, xs: 12 }}>
                    <Box className="mb-4">
                        {/* El punto de venta sólo trabaja con ventas, así
                                que el interlocutor siempre es el comprador. */}
                        <SttSelectMship
                            readOnly={readOnly}
                            caption={t('User')}
                            mship={mship}
                            onSelect={setMship}
                        />
                    </Box>

                    <SalePointCart
                        cart={cart}
                        saveMovementInCart={saveMovementInCart}
                        totalNet={totalNet}
                        totalVat={totalVat}
                        total={total}
                        readOnly={readOnly}
                    />

                    {total !== 0 && !readOnly && (
                        <SalePointPayment
                            ticket={ticket}
                            mship={mship}
                            total={total}
                            onUpdateTicket={(ticketToUpdate: any) => {
                                setTicket(ticketToUpdate);
                            }}
                            onReset={reset}
                        />
                    )}
                </Grid>
            </Grid>
        </Box>
    );
}
